import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "project-scope-grid"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"project-scope-grid__row\"><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Ref.</p></div><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Date</p></div><div class=\"project-scope-grid__col project-scope-grid__col--3\"><p class=\"project-scope-grid__heading\">Description</p></div><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Fee</p></div></div>", 1)
const _hoisted_4 = { class: "project-scope-grid__row" }
const _hoisted_5 = { class: "project-scope-grid__col project-scope-grid__col--full-width" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "project-scope-grid" }
const _hoisted_8 = { class: "project-scope-grid__row" }
const _hoisted_9 = { class: "project-scope-grid__col" }
const _hoisted_10 = { class: "project-scope-grid__content" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "u" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "project-scope-grid__col" }
const _hoisted_15 = { class: "project-scope-grid__content" }
const _hoisted_16 = { class: "project-scope-grid__col project-scope-grid__col--3" }
const _hoisted_17 = { class: "project-scope-grid__content" }
const _hoisted_18 = { class: "project-scope-grid__col" }
const _hoisted_19 = { class: "project-scope-grid__content" }
const _hoisted_20 = { class: "accordion__content" }
const _hoisted_21 = { class: "project-scope-grid" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"project-scope-grid__row\"><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Deliverable</p></div><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Project grid</p></div><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Price</p></div><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Price with discount</p></div><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Quantity</p></div><div class=\"project-scope-grid__col\"><p class=\"project-scope-grid__heading\">Subtotal</p></div></div>", 1)
const _hoisted_23 = { class: "project-scope-grid__col" }
const _hoisted_24 = { class: "project-scope-grid__content" }
const _hoisted_25 = { class: "project-scope-grid__col" }
const _hoisted_26 = { class: "project-scope-grid__content" }
const _hoisted_27 = { class: "project-scope-grid__col" }
const _hoisted_28 = { class: "project-scope-grid__content" }
const _hoisted_29 = { class: "project-scope-grid__col" }
const _hoisted_30 = { class: "project-scope-grid__content" }
const _hoisted_31 = { class: "project-scope-grid__col" }
const _hoisted_32 = { class: "project-scope-grid__content" }
const _hoisted_33 = { class: "project-scope-grid__col" }
const _hoisted_34 = { class: "project-scope-grid__content" }
const _hoisted_35 = { class: "project-scope-grid__row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "project-scope-grid__col project-scope-grid__col--5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "project-scope-grid__content" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Total")
  ])
], -1 /* HOISTED */)
const _hoisted_37 = { class: "project-scope-grid__col" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (!$setup.project_scope || !$setup.project_scope.length)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, " No scope added "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.project_scope, (scope, scope_index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'scope-' + scope_index,
                class: _normalizeClass(["accordion", { 'accordion--expanded': scope.expanded }])
              }, [
                _createElementVNode("button", {
                  onClick: $event => ($setup.expandScope( scope )),
                  class: "accordion__trigger"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, [
                          (scope.pandadoc_id)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "external flex flex--inline flex--align-center flex--gap-medium",
                                href: 'https://app.pandadoc.com/a/#/documents/' + scope.pandadoc_id,
                                target: "_blank"
                              }, [
                                _createElementVNode("span", _hoisted_12, _toDisplayString(scope.sequence_prefix), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_11))
                            : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(scope.sequence_prefix), 1 /* TEXT */))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString($setup.formatDate( scope.dateCreated )), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(scope.title), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("p", _hoisted_19, [
                          _createElementVNode("span", {
                            class: _normalizeClass({
												'error': scope.total <= 0,
												'green': scope.total > 0
											})
                          }, _toDisplayString($setup.formatFee( scope.total )), 3 /* TEXT, CLASS */)
                        ])
                      ])
                    ])
                  ])
                ], 8 /* PROPS */, _hoisted_6),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.scope_items, (item, item_index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'scope-' + scope_index + 'item-' + item_index,
                        class: "project-scope-grid__row project-scope-grid__row--compact"
                      }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("p", _hoisted_24, _toDisplayString(item.item_name), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("p", _hoisted_26, [
                            ($setup.getMediaType( item ))
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "u",
                                  to: {
												name: 'projects__project',
												params: {
													project_id: $setup.route.params.project_id
												},
												query: {
													tab: 'grid',
													type: $setup.getMediaType( item ).slug
												}
											}
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.getMediaType( item ).title), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("p", _hoisted_28, _toDisplayString($setup.formatFee( item.price_per_unit )), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("p", _hoisted_30, _toDisplayString($setup.formatFee( item.price_per_unit_after_discount )) + _toDisplayString(item.discount_percentage ? '(' + item.discount_percentage + ')' : ''), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(item.quantity), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("p", _hoisted_34, _toDisplayString($setup.formatFee( item.total )), 1 /* TEXT */)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("p", {
              class: _normalizeClass(["project-scope-grid__content", { 'error': $setup.total <= 0 }])
            }, [
              _createElementVNode("strong", null, _toDisplayString($setup.formatted_total), 1 /* TEXT */)
            ], 2 /* CLASS */)
          ])
        ])
      ]))
}